import { render, staticRenderFns } from "./grid_paging.vue?vue&type=template&id=beab9962"
import script from "./grid_paging.vue?vue&type=script&lang=js"
export * from "./grid_paging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports